"use client";

import styled from "styled-components";

export const Button = styled.button`
  padding: 3px;
  border-radius: 100px;
  border: none;
  background: var(--primarySystem100);
  cursor: pointer;

  svg {
    width: 25px;
    height: 25px;
    color: var(--primary);
  }

  &:hover {
    background: var(--primarySystem500);
  }
`;
